import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

const ADD_APP_TO_ENTITY = gql`
  mutation addAppLink($appId: String!, $eId: String!, $eType: EEntityType!) {
    app {
      addAuhorizedEntities(
        inputType: {
          appIdentifier: $appId
          entities: { entityId: $eId, entityType: $eType }
        }
      )
    }
  }
`;

const AddAppToEntity = ({ eId, eType, appId, onError, onSuccess }) => (
  <Mutation mutation={ADD_APP_TO_ENTITY}>
    {(addAppLink, { loading, error, data }) => {
      const variables = {
        eId,
        eType,
        appId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccess(data.app.addAuhorizedEntities);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={addAppLink}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

AddAppToEntity.propTypes = {
  appId: PropTypes.string.isRequired,
  eId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  eType: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AddAppToEntity;
